<template>
  <v-row class="pa-4 bg-page">
    <!-- Vue d'ensemble -->
    <v-col cols="12" md="4">
      <v-card outlined class="rounded-xl modern-card shadow-sm fill-height">
        <v-card-title class="d-flex align-center pb-4">
          <v-icon color="primary" class="mr-2">mdi-chart-donut</v-icon>
          <span
            class="text-subtitle-1 font-weight-bold grey--text text--darken-3"
            >{{ $t("_vue_d_ensemble_") }}</span
          >
        </v-card-title>

        <v-card-text>
          <div class="status-grid">
            <div class="status-item live">
              <span class="label">{{ $t("_live_") }}</span>
              <span class="value">{{ statusCounts.live }}</span>
            </div>
            <!-- <div class="status-item suspendu">
              <span class="label">{{ $t("_suspendu_") }}</span>
              <span class="value">0</span>
            </div>
            <div class="status-item submitted">
              <span class="label">{{ $t("_soumis_") }}</span>
              <span class="value">{{ statusCounts.soumis }}</span>
            </div>
            <div class="status-item reprendre">
              <span class="label">{{ $t("_a_reprendre_") }}</span>
              <span class="value">{{ statusCounts.na }}</span>
            </div>
            <div class="status-item en_cours">
              <span class="label">{{ $t("_en_cours_de_validation_") }}</span>
              <span class="value">0</span>
            </div>
            <div class="status-item error">
              <span class="label">{{ $t("_echec_") }}</span>
              <span class="value">0</span>
            </div> -->
          </div>

          <v-divider class="my-6"></v-divider>

          <div
            class="d-flex align-center justify-space-between total-footer pa-3 rounded-lg"
          >
            <span class="text-overline grey--text">{{ $t("_live_") }}</span>
            <span class="text-h6 font-weight-black primary--text">{{
              statusCounts.live
            }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Explorateur -->
    <v-col cols="12" md="4">
      <v-card outlined class="rounded-xl modern-card shadow-sm fill-height">
        <v-card-title class="pb-2 d-flex align-center">
          <v-icon color="success" class="mr-2"
            >mdi-office-building-marker</v-icon
          >
          <span
            class="text-subtitle-1 font-weight-bold grey--text text--darken-3"
          >
            {{ $t("_explorateur_") }}</span
          >
        </v-card-title>

        <v-card-text>
          <!-- Barre de recherche filtrant les groupes -->
          <v-text-field
            v-model="searchGroup"
            :label="$t('_rechercher_un_groupe_')"
            solo            
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            class="rounded-lg mb-2"
          ></v-text-field>

          <!-- Boutons de style esthétique (pas de filtrage) -->
          <!-- <div class="d-flex mb-4" style="gap: 8px;">
            <v-btn
              color="blue darken"
              class="filter-btn white--text"
              rounded
              @click.prevent
            >
              Tous les groupes
            </v-btn>
            <v-btn
              color="blue darken"
              class="filter-btn white--text"
              rounded
              @click.prevent
            >
              Sans groupe
            </v-btn>
          </div> -->

          <!-- Liste des groupes filtrés par la recherche uniquement -->
          <v-list class="pa-0 transparent site-list-scroll">
            <v-list-item
              v-for="group in filteredGroups"
              :key="group.id"
              class="rounded-lg mb-2 site-item"
              @click="selectedGroup = group.id"
              :active="selectedGroup === group.id"
            >
              <v-list-item-avatar size="32" color="primary lighten-5">
                <v-icon small color="primary">mdi-account-group</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium text-truncate">{{
                  group.name
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small color="grey lighten-1">mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Actions -->
    <v-col cols="12" md="4">
      <v-card
        outlined
        class="rounded-xl modern-card shadow-sm fill-height control-panel"
      >
        <v-card-title class="pb-6 d-flex align-center">
          <v-icon color="orange darken-2" class="mr-2"
            >mdi-tune-vertical</v-icon
          >
          <span
            class="text-subtitle-1 font-weight-bold grey--text text--darken-3"
            >{{ $t("_actions_") }}</span
          >

          <v-spacer></v-spacer>

          <transition name="fade-transition" mode="out-in">
            <v-chip
              v-if="selectedGroup"
              color="primary lighten-5"
              label
              small
              close
              close-icon="mdi-close-circle"
              @click:close="selectedGroup = null"
              class="font-weight-bold rounded-lg primary--text"
            >
              {{ allGroups.find((g) => g.id === selectedGroup)?.name }}
            </v-chip>
          </transition>
        </v-card-title>

        <v-card-text>
          <div v-if="selectedGroup" class="action-container mt-2">
            <v-btn
              block
              depressed
              color="success lighten-5"
              class="mb-3 text-none justify-start action-btn success--text text--darken-2"
              height="48"
              @click="$emit('add-install-to-group', getSelectedGroup())"
            >
              <v-icon left>mdi-plus-circle-outline</v-icon>
              {{ this.$t("_add_install_to_groupe_") }}
            </v-btn>

            <v-btn
              block
              depressed
              color="orange lighten-3"
              class="mb-3 text-none justify-start action-btn warning--text text--darken-2"
              height="48"
              @click="$emit('remove-install-from-group', getSelectedGroup())"
            >
              <v-icon left>mdi-minus-circle</v-icon>
              {{ this.$t("_remove_install_from_groupe_") }}
            </v-btn>

            <v-divider class="my-4"></v-divider>
            <v-btn
              block
              depressed
              color="blue lighten-5"
              class="mb-3 text-none justify-start action-btn blue--text text--darken-3"
              height="48"
              @click="$emit('rename-group', getSelectedGroup())"
            >
              <v-icon left>mdi-pencil-outline</v-icon>
              {{ $t("_renommer_le_groupe_") }}
            </v-btn>

            <v-btn
              block
              depressed
              color="error lighten-5"
              class="mb-3 text-none justify-start action-btn error--text text--darken-2"
              height="48"
              @click="$emit('delete-group', selectedGroup)"
            >
              <v-icon left>mdi-delete-outline</v-icon>
              {{ $t("_supprimer_le_groupe_") }}
            </v-btn>

            <v-btn
              block
              text
              color="grey darken-1"
              class="text-none action-btn"
              height="48"
              @click="selectedGroup = null"
            >
              {{ $t("_annuler_la_selection_") }}
            </v-btn>
          </div>

          <!-- <v-btn block depressed class="mb-4 text-none action-btn" height="52" style="background-color:#ec4899; color:white;">
            <v-icon left>mdi-account-group</v-icon> Gestion des membres
          </v-btn> -->
          <div v-else class="action-container mt-2">
            <v-btn
              block
              depressed
              color="primary"
              class="mb-4 text-none justify-start action-btn shadow-blue"
              height="52"
              @click="$emit('add-group')"
            >
              <v-icon left>mdi-plus</v-icon> {{ $t("_ajouter_un_groupe_") }}
            </v-btn>

            <v-btn
              block
              depressed
              color="indigo darken-1"
              class="mb-4 text-none justify-start action-btn shadow-indigo white--text"
              height="52"
              @click="$emit('add-audit')"
            >
              <v-icon left>mdi-clipboard-plus-outline</v-icon>
              {{ $t("_ajouter_audit_") }}
            </v-btn>

            <v-btn
              block
              depressed
              color="teal darken-1"
              class="mb-4 text-none justify-start action-btn shadow-teal white--text"
              height="52"
              @click="$emit('import-excel')"
            >
              <v-icon left>mdi-file-excel-outline</v-icon>
              {{ $t("_importer_excel_") }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PremiumDashboard",
  props: {
    installations: { type: Array, default: () => [] },
    sitesLive: { type: Array, default: () => [] },
    allGroups: { type: [Array, Object], default: () => [] },
  },
  data() {
    return {
      selectedGroup: null,
      searchGroup: "",
    };
  },
  computed: {
    statusCounts() {
      const counts = { live: 0, soumis: 0, na: 0 };
      this.installations.forEach((inst) => {
        const site = this.sitesLive.find((s) => s.installation_id == inst.id);
        if (site) {
          if (site.is_new && !site.is_active) counts.soumis++;
          else if (site.status == "live") {
            counts.live++;
          }
        } else {
          counts.na++;
        }
      });
      return counts;
    },
    flattenedGroups() {
      return Array.isArray(this.allGroups) ? this.allGroups : [];
    },
    filteredGroups() {
      const groups = this.flattenedGroups;
      if (!this.searchGroup) return groups;

      const search = this.searchGroup.toLowerCase();
      return groups.filter(
        (g) => g.name && g.name.toLowerCase().includes(search)
      );
    },
  },
  methods: {
    getSelectedGroup() {
      return this.allGroups.find((g) => g.id === this.selectedGroup);
    },
  },
};
</script>

<style scoped>
.modern-card {
  background-color: #ffffff !important;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s ease;
}
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02),
    0 2px 4px -1px rgba(0, 0, 0, 0.01) !important;
}

/* Status Grid */
.status-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.status-item {
  padding: 16px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
}
.status-item .label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.8;
  margin-bottom: 4px;
}
.status-item .value {
  font-size: 1.25rem;
  font-weight: 800;
}

.live {
  background-color: #f0fdf4;
  color: #16a34a;
}
.submitted {
  background-color: #fefce8;
  color: #ca8a04;
}
.reprendre {
  background-color: #f0f9ff;
  color: #0284c7;
}
.en_cours {
  background-color: #fff0f6;
  color: #d6336c;
}
.suspendu {
  background-color: #fdf4ff;
  color: #9333ea;
}
.error {
  background-color: #fff5f5 !important;
  color: #d32f2f !important;
}

.total-footer {
  background-color: #f8fafc;
  border: 1px dashed #e2e8f0;
}

/* Liste explorateur */
.site-list-scroll {
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: normal;
}
.site-item {
  cursor: pointer;
  transition: all 0.2s;
}
.site-item:hover {
  background-color: #f3f4f6 !important;
  transform: translateX(2px);
}
.site-item.v-item--active {
  background-color: #e0f2fe !important;
}

.filter-btn {
  flex: 1;
  font-weight: 600;
  text-transform: none;
  min-height: 25px;
  transition: all 0.2s;
}
.filter-btn:hover {
  background-color: #bbdefb;
}
.filter-btn:last-child {
  margin-right: 0;
}

.shadow-blue {
  box-shadow: 0 4px 12px 0 rgba(25, 118, 210, 0.25) !important;
}
.shadow-indigo {
  box-shadow: 0 4px 12px 0 rgba(57, 73, 171, 0.25) !important;
}
.shadow-teal {
  box-shadow: 0 4px 12px 0 rgba(0, 137, 123, 0.25) !important;
}

.action-btn {
  border-radius: 12px !important;
  font-weight: 600;
  transition: all 0.3s ease;
}

/* Effet de survol pour tous les boutons */
.action-btn:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  border: 2px dashed #f1f5f9;
  border-radius: 20px;
}
</style>
